<script setup lang="ts">
import type { Article } from "~/types/article"

defineProps({
  data: {
    type: Object as PropType<Article>,
    default: () => {},
  },
})
</script>

<template>
  <div
    :id="`template-${data.id}`"
    class="flex flex-col items-center justify-start w-full gap-10 overflow-y-scroll text-white bg-darker"
  >
    <div class="w-[80%] max-w-[100em] flex-col gap-6 py-32">
      <UArticleHeader
        :data="data"
        class="flex flex-col items-start justify-center md:px-20 lg:px-40"
      />
      <URichText
        class="pt-8 text-lg md:px-20 lg:px-40 lg:text-xl xl:mb-12"
        :html="data.intro?.html"
      />
      <UVideo
        v-if="data.video"
        :video="data.video"
        :title="data.title"
      />
    </div>
  </div>
</template>
